<template>
  <div>
    <div class="page-title">
      <div class="container">
        <lesson-filter />
      </div>
    </div>

    <div class="container">
      <empty-page class="pt-3 pb-3" title="查無任何課程" description="此類別沒有任何課程。" v-if="!lessonList.list" />

      <div class="row pt-3 pb-3">
        <div class="col-12 col-sm-6 col-md-3 p-1" v-for="lesson in lessonList.list" :key="lesson.id" :lang="lesson.language">
          <div class="card" style="max-width: 100%;" @click="$router.push('/lessons/play/' + lesson.id)">
            <img class="card-img-top" :src="lesson.cover ? lesson.cover : 'https://via.placeholder.com/300x250'">
            <div class="card-body text-left" :style="{ 'letter-spacing': '2px', 'height': '120px', 'overflow-y': 'hidden' }">
              <h5 class="card-title mb-0" v-html="forceToJap(lesson.name)"></h5>
              <p class="card-text">{{ lesson.localName }}</p>
            </div>
            <ul class="list-group list-group-flush ml-2 mr-2">
              <li class="border-top pl-0 pr-0 pt-3 pb-3" style="line-height: 300%; list-style: none;">
                <span class="float-right">
                  <span class="p-0 pl-3 pr-3 text-white btn-category content" v-if="lesson.language">{{ lesson.language }}</span>
                  <span class="p-0 pl-3 pr-3 text-white btn-category user-target" v-if="lesson.categoryName">{{ lesson.categoryName }}</span>
                  <span class="p-0 pl-3 pr-3 text-white btn-category level" v-if="lesson.level">{{ lesson.level }}</span>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <pagination :current="lessonList.pageIndex" :total="lessonList.pageCount" v-on:page="updatePage" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Pagination from '../components/Pagination'
import LessonFilter from '../components/LessonFilter'
import langMixin from '../components/langMixin'
import EmptyPage from './Teacher/EmptyPage'

export default {

  name: 'Lessons',

  components: {
    Pagination,
    LessonFilter,
    EmptyPage
  },

  mixins: [langMixin],

  data () {
    return {

    }
  },

  computed: {
    ...mapGetters([
      'lessonList',
      'lessonFilters'
    ])
  },

  mounted () {
    this.getLessonFilters()
    this.getLessonList()
  },

  methods: {
    ...mapActions([
      'getLessonList',
      'getLessonFilters'
    ]),

    updatePage (page) {
      this.getLessonList({
        'pageIndex': page
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .card {
    cursor: pointer;

    .card-title {
      font-size: 16px;
    }

    .card-body {
      font-size: 14px;
    }

    &:hover {
      box-shadow: 0 0 8px #a1a1a1;
      transition: box-shadow 0.2s ease-in-out;
    }
  }
</style>



// WEBPACK FOOTER //
// Lessons.vue?b7b22f80